"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Relation = exports.REL_ACTION_OPTIONS = void 0;
exports.REL_ACTION_OPTIONS = {
    "Advert": [
        null,
        "advert.view",
        "advert.click",
        "quiz.view",
        "quiz.answered",
    ],
    "Keyword": [
        "search",
    ],
    "Document": [
        null,
        "document.view",
    ],
};
class Relation {
    constructor(data) {
        this.type = "m";
        this.kind = "required";
        this.event = null;
        this.caping = null;
        if (data) {
            for (let prop in data) {
                if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                    this[prop] = data[prop];
                }
            }
        }
    }
}
exports.Relation = Relation;
//# sourceMappingURL=Relation.js.map